export default class tccf7Observation {
  constructor( base , callback ) {
    this.elem             = base.elem;
    this.form             = base.form;
    this.observer         = null;
    this.callback         = callback; 
    this.currentHeight    = this.form.clientHeight;
    this.targetHeight     = this.form.clientHeight;
    this.shouldScroll      = false;

    this.debounceObserver = this.checkObserver.bind(this);
    this.initObserver(); 
  }

  initObserver() {
    this.observer = new MutationObserver(this.debounceObserver);
    const config = {
      childList: true, 
      subtree: true
    };
    this.observer.observe(this.elem, config);
  }

  checkObserver() {
    requestAnimationFrame(() => {
      if (typeof this.callback === "function") {
        this.callback();
      }
    });
  }
  
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}